<ng-progress ngProgressRouter class="print:hidden" />

<customer-portal-layout class="block" #layout />
